module.exports = __webpack_public_path__ + "static/34-thumb-03a0aaf5250e3a2e322e5d077a37c578.jpg";